/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryRunnerAPI'
], (APIFactory, QueryRunnerAPI) => {

	/**
	  * @class QueryOptimizerService
	  *
	  * @classdesc Sets up/links query optimizers. Has 1 optimizer implementation :
	  * QueryGroupOptimizer :  groups requests for multiple widgets into 1 request, splits back results back to individual widgets
	  */
	class QueryOptimizerService {
		constructor(options) {
			this.params = options.options;
			this.queryGroupOptimizer = options.features['QueryGroupOptimizer'];
		}

		setup( queryService ) {
			this.queryService = queryService;
			this.queryGroupOptimizer.setup(this.queryService, this.params);
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [QueryRunnerAPI]);
			}
			return this.api;
		}

		runQuery(options) {
			return this.queryGroupOptimizer.runQuery(options);
		}
	}

	return QueryOptimizerService;
});
